import Box from '@mui/material/Box';
import { type ReactNode } from 'react';

import { AppCard } from '@/components/atoms';
import { type IconKey } from '@/content/site';

import { FooterHeading } from './FooterHeading';

type Props = { icon: IconKey; title: string; children: ReactNode };

/** A contact detail group on a raised card: office, phones or hours. */
export function ContactCard({ icon, title, children }: Props) {
  return (
    <AppCard
      component="section"
      sx={{
        height: '100%',
        p: { xs: 5, md: 6 },
        transition: 'border-color 200ms, box-shadow 200ms, transform 200ms',
        '&:hover': {
          borderColor: 'rgba(var(--mui-palette-primary-mainChannel) / 0.35)',
          boxShadow: '0 12px 32px -16px rgba(var(--mui-palette-primary-mainChannel) / 0.35)',
          transform: 'translateY(-2px)',
        },
      }}
    >
      <FooterHeading icon={icon} title={title} />
      <Box sx={{ mt: 4, pl: { sm: 12 } }}>{children}</Box>
    </AppCard>
  );
}
